import { sendStatsService } from "@resources/js/services/stats.service"
import generateStatsLabelString from "@resources/js/helpers/generateStatsLabelString"


const sendStats = ({type=null, partnerUrl=null, action="open", category="clickunder", logId} = {}) => {
    const labelString = generateStatsLabelString({ type, partnerUrl })

    const options =  {
        id: logId || shared.options?.log?.id,
        c: category,
        a: action,
        l: labelString
    }

    sendStatsService(options)
}

export default sendStats
